/**
 * Trigger browser download for a Blob / File.
 */
export function downloadBlob(blob, fileName) {
  const safeName = String(fileName || 'export.xlsx')
    .replace(/[^\w.-]+/g, '_')
    .replace(/_+/g, '_');
  const withExt = /\.xlsx$/i.test(safeName) ? safeName : `${safeName}.xlsx`;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = withExt;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function fileNameFromContentDisposition(header, fallback = 'export.xlsx') {
  if (!header) return fallback;
  const match =
    /filename\*=UTF-8''([^;]+)|filename="([^"]+)"|filename=([^;]+)/i.exec(
      String(header),
    );
  const raw = decodeURIComponent(
    (match?.[1] || match?.[2] || match?.[3] || '').trim(),
  );
  return raw || fallback;
}

export function exportFileStamp(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}`;
}

/**
 * Download an Excel export API response (axios blob response).
 */
export function downloadExcelResponse(response, fallbackFileName) {
  const fileName = fileNameFromContentDisposition(
    response?.headers?.['content-disposition'],
    fallbackFileName || `export_${exportFileStamp()}.xlsx`,
  );
  downloadBlob(response.data, fileName);
  return fileName;
}
